import template from './expense-import.html';
import controller from './expense-import.controller';

let expenseImportComponent = {
  restrict: 'E',
  template,
  controller
};

export default expenseImportComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/expense-import/expense-import.component.js